/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Redirect } from "react-router-dom";
import get from "lodash/get";
import {
  RangePicker, ThemeActionButton, BarLoader, GenericLoader,
} from "../../../../shared/widgets";
import "../reportView.css";
import Hidden from "@material-ui/core/Hidden";
import { ButtonToolbar } from "react-bootstrap";
import { templateStrings } from "../../../../Constant";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { mobileTicketAction, runSettlementAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { routes } from "../../../../routing/routes";

class MobileTicketReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.mobileTicketReportGetList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter != this.props.cityFilter)
            || (prevProps && prevProps.operatorFilter != this.props.operatorFilter)
            || (prevProps && prevProps.dateFilter != this.props.dateFilter)
    ) {
      this.mobileTicketReportGetList();
    }
  }

  handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      this.props && this.props.selectDateFilter({ fromDate, toDate });
    }
  };

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.mobileTicketReportGetList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.mobileTicketReportGetList();
      }
    });
  };

  handleSettlement = (details) => {
    this.props.runSettlement({
      dateFilter: {
        fromDate: new Date(get(details, "fromDate", null)).getTime(),
        toDate: new Date(get(details, "toDate", null)).getTime(),
      },
      cityId: get(details, "cityId", ""),
      agencyId: get(details, "agencyId", ""),
    }, "settlementLoader", this.mobileTicketReportGetList);
  };

  handleAction = (details) => {
    const { history } = this.props;
    history.push("/report/mobile-ticket/mobile-ticket-details", details);
  };

  mobileTicketReportGetList = () => {
    this.props.mobileTicketsReportFetched({
      pageNo: this.state.pageNo,
      pageSize: this.state.rowsPerPage,
      dateFilter: this.props.dateFilter,
      cityFilter: this.props.cityFilter,
      operatorFilter: this.props.operatorFilter,
      sortBy: this.state.sortBy,
    }, "header");
  };

  settlementRowComponent = (rowDetails) => (
    rowDetails.isOldMonth && rowDetails.settleStatus && (
      <ThemeActionButton
        onClick={(event) => {
          event.stopPropagation();
          if (rowDetails.settleStatus) return this.handleSettlement(rowDetails);
          this.props.history.push("/report/mobile-ticket/residual-settlement", rowDetails);
        }}
        buttonText={rowDetails.settleStatus.settled ? "Check Distribution" : "Generate Distribution"}
      />
    )
  );

  render() {
    const {
      headerLoader, content, totalItems, selectedReports,
    } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.reportMobileTickets;
    templateString.settleUnused.component = this.settlementRowComponent;
    return (
      <div className="pageContainer">
        {!!this.props.settlementLoader && (
          <GenericLoader absolute />
        )}
        {selectedReports == "distance"
                  && (
                    <Redirect
                      to={{
                        pathname: routes.DISTANCE_REPORT,
                        state: { from: this.props.location },
                      }}
                    />
                  )}
        <PageWrapper>
          <PageWrapper.Header heading="Mobile Tickets" hideS>
            <Hidden only={["sm", "xs"]}>
              <div className="pull-right z-index-10">
                <ButtonToolbar>
                  <RangePicker
                    startDate={moment(new Date(this.props.dateFilter.fromDate))}
                    endDate={moment(new Date(this.props.dateFilter.toDate))}
                    monthsToDisplay={1}
                    onDatesChange={this.handleDatesChange}
                  />
                </ButtonToolbar>
              </div>
            </Hidden>
          </PageWrapper.Header>
          <BarLoader scope="header" />
          <TableWrapper
            content={!headerLoader && content}
            pageNo={pageNo}
            selected={selected}
            uniqueKey="uniqKey"
            rowsPerPage={rowsPerPage}
            count={totalItems}
            handleChange={this.handleChange}
            templateString={templateString}
            selectionAllowed={false}
            onSortToggle={this.onSortToggle}
            sortBy={sortBy}
            handleAction={this.handleAction}
            handleSettlement={this.handleSettlement}
          />
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
        (state && state.Report && state.Report.mobileTicketData && state.Report.mobileTicketData.data) || [],
    totalItems:
        (state && state.Report && state.Report.mobileTicketData && state.Report.mobileTicketData.totalItems) || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    settlementLoader: (state && state.loadingBar && state.loadingBar.settlementLoader),
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedReports: state.ReportsType.selectedReportsType,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  mobileTicketsReportFetched: (params, loaderScope) => {
    dispatch(mobileTicketAction(params, loaderScope));
  },
  runSettlement: (value, loaderScope, callBack) => {
    dispatch(runSettlementAction(value, loaderScope, callBack));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileTicketReport);
